export function cls(...args: (string | undefined)[]) {
  return args.filter(Boolean).join(" ");
}

export function clx(classes: Record<string, boolean>) {
  return Object.entries(classes)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(" ");
}
